(function () {
    'use strict';
    angular.module('wbDashboard').directive('pulseAurea', ['$window', '$timeout', function ($window, $timeout) {
        return {
            // replace: true,
            restrict: 'A',
            scope: {
                data: '=',
                config: '=?',
                label: '@',
                onClick: '&'
            },
            templateUrl: "app/themes/aurea/directives/pulse/pulse.tpl.html",
            link: function (scope, el, attrs) {

                var blipLength = 30;
                var blipCount = 15;
                var blipDelay = 10;
                var blipDurration = 2000; //milliseconds

                var svg = d3.select(el[0]).select('svg');
                var pulse = svg.select('.wb-pulse');
                var pulseLength = pulse.node().getTotalLength() + (blipCount+1)*blipDelay + blipLength;
                var clonePulse = [];
                var c;

                for (let i = 1; i < blipCount+1; i++) {
                    c = clone('.wb-pulse');
                    c
                        .attr('stroke', 'rgba(75, 169, 214,'+(blipCount + 1 - i) * 0.04+')')
                        .attr('stroke-dasharray', `${blipLength}px ${pulseLength}px`);

                    if (i === blipCount) {
                        //faintest lasts one, make longer
                        c.attr('stroke-dasharray', `${blipLength*20}px ${pulseLength}px`);

                    }

                    newTween(c, i);
                    clonePulse.push(c);
                }

                pulse.attr('stroke-dasharray', `${blipLength/2}px ${pulseLength}px`);
                pulse.attr('stroke', 'rgba(75, 169, 214,1)');
                pulse.attr('filter', 'url(#glow)');
                newTween(pulse, 0);

                animate();

                function newTween(path, index) {
                    path.dataset = { offset: -blipLength };
                    new TWEEN.Tween( path.dataset )
                        .to( { offset: pulseLength }, blipDurration )
                        .easing(TWEEN.Easing.Quadratic.InOut)
                        .repeat( Infinity )
                        .onUpdate(function() {
                            updatePath(path, index, this);
                        })
                        .start();
                }

                function updatePath(path, offsetMultiplier, tweenObj) {
                    var offset = path.dataset.offset - offsetMultiplier*blipDelay;
                    if (offsetMultiplier !== 0) {
                        offset -= 10;
                    }
                    if (offsetMultiplier === blipCount) {
                        offset -= blipLength * 20;
                        path.attr('opacity', 1.3 - path.dataset.offset/pulseLength);
                    }
                    path.attr('stroke-dashoffset', offset*-1 + "px");
                }

                function clone(selector) {
                    var node = svg.select(selector).node();
                    // return d3.select(node.parentNode.insertBefore(node.cloneNode(true), node.nextSibling));
                    // return d3.select(node.insertBefore(node, node.cloneNode(true)));
                    return d3.select(node.parentElement.insertAdjacentElement('afterbegin', node.cloneNode(true)));
                }

                function animate() {
                    window.requestAnimationFrame(animate);
                    TWEEN.update();
                }

            }
        };
    }]);
})();
